import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { Button, Col, Modal, ModalHeader, ModalBody, Row } from "reactstrap";
import { CreateNewOrganization } from "services/OrganizationServices";
import cross from "../../assets/images/icon/cross.svg";
const CreateOrganizationModal = ({
  t,
  addModal,
  setAddModal,
  fetchData,
  ...props
}) => {
  const [orgDetails, setOrgDetails] = useState({});
  const [errors, setErrors] = useState({});

  const toggleAddModal = () => {
    setAddModal(!addModal);
    setOrgDetails({});
    setErrors({});
  };

  const handleSaveClick = async () => {
    try {
      let errors = {};
      const nameRegex = /^[A-Za-z\s.]+$/;
      const addressRegex = /^[A-Za-z0-9\s\.,#\-]+$/;
  
      if (!orgDetails?.name?.trim()) {
        errors.name = t(`Organization.Name is required`);
      } else if (!nameRegex.test(orgDetails.name.trim())) {
        errors.name = t(`Organization.Name should contain only alphabets and spaces`);
      } else {
        errors.name = null;
      }
  
      if (!orgDetails?.address?.trim()) {
        errors.address = t(`Organization.Address is required`);
      } else if (!addressRegex.test(orgDetails.address.trim())) {
        errors.address = t(`Organization.Address should contain only alphanumeric characters`);
      } else {
        errors.address = null;
      }

      if (!!Object.values(errors).some(val => !!val)) {
        setErrors(errors);

        setTimeout(() => {
          setErrors({});
        }, 2500);

        return;
      }

      let reqBody = {
        name: orgDetails?.name?.trim(),
        address: orgDetails?.address?.trim(),
      };

      let response = await CreateNewOrganization(reqBody);

      let responseMsg =
        response?.data?.message || "Organization Created Successfully";

      toast.success(responseMsg);

      setTimeout(() => {
        toggleAddModal();

        fetchData({});
      }, 1000);
    } catch (error) {
      let errMsg =
        error?.response?.data?.message ||
        error?.response?.message ||
        error?.message ||
        "Error while creating organization";

      let errors = error?.response?.data?.errors || {};
      setErrors(errors);

      setTimeout(() => {
        setErrors({});
      }, 2500);

      toast.error(errMsg);
    }
  };

  return (
    <>
      <div className="edit-modal">
        <Modal
          size="lg"
          isOpen={addModal}
          centered
          backdrop="static"
          toggle={toggleAddModal}
          className="edit-modal-card ediOrganizations"
        >
          <ModalBody>
            <div className="filters-cards-cross">
              <div className="filter-content">
                <h4> {t(`Organization.Add Organization Details`)}</h4>
              </div>
              <div className="filter-content cross">
                <img
                  src={cross}
                  alt=""
                  onClick={() => {
                    toggleAddModal();
                  }}
                />
              </div>
            </div>
            <div className="">
              <Row className="">
                <Col md={12} className="">
                  <Form.Group className="mb-2 floating-label">
                    <Form.Label className="float-label">
                      {t(`Organization.Name`)}
                      <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      placeholder={t(`Organization.Enter Name`)}
                      type="text"
                      name="name"
                      value={orgDetails?.name}
                      onChange={e => {
                        setOrgDetails({
                          ...orgDetails,
                          name: e.target.value,
                        });
                        setErrors({
                          ...errors,
                          name: !!e?.target?.value?.trim()
                            ? null
                            : t("Organization.Name is required"),
                        });

                        setTimeout(() => {
                          setErrors({
                            ...errors,
                            name: null,
                          });
                        }, 2500);
                      }}
                      title={t(`Organization.Name`)}
                    />
                    {errors?.name && (
                      <p className="text-danger">{errors?.name}</p>
                    )}
                  </Form.Group>
                </Col>

                <Col md={12} className="mt-2">
                  <Form.Group className="mb-2 floating-label">
                    <Form.Label className="float-label">
                      {t(`Organization.Address`)}
                    </Form.Label>
                    <Form.Control
                      rows="4"
                      as="textarea"
                      placeholder={t(`Organization.Enter Address`)}
                      name="address"
                      value={orgDetails?.address}
                      onChange={e => {
                        setOrgDetails({
                          ...orgDetails,
                          address: e.target.value,
                        });
                      }}
                      title={t(`Organization.Address`)}
                    />
                     {errors?.address && (
                      <p className="text-danger">{errors?.address}</p>
                    )}
                  </Form.Group>
                </Col>

                <Col md={12} className="d-flex gap-2 mt-4">
                  <button
                    className="btn btn-primary reset"
                    onClick={() => {
                      toggleAddModal();
                    }}
                  >
                    {t(`Organization.Cancel`)}
                  </button>
                  <button
                    className="btn btn-primary search"
                    onClick={() => handleSaveClick()}
                  >
                    {t(`Organization.Save`)}
                  </button>
                </Col>
              </Row>
            </div>
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};

export default CreateOrganizationModal;
